import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { ownerscabinImageOptions } from './views/ownerscabin'

class X49MK2OwnersCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsChange = this.handleCupboardsChange.bind(this);
        this.handleBeautyBoxChange = this.handleBeautyBoxChange.bind(this);
    }


    handleCupboardsChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsOwnersCabin = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBeautyBoxChange(event) {
        let configuration = this.props.configuration;
        configuration.BeautyBox = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = ownerscabinImageOptions;

        let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Owner’s cabin' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='X49 Owner’s cabin Furniture Text 1' /></p>
                    <p><Trans defaults='X49 Owner’s cabin Furniture Text 2' /></p>
                    <Toggle checked={this.props.configuration.CupboardsOwnersCabin.value === 2} onChange={this.handleCupboardsChange}>
                        <Trans defaults='Upper cupboards' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.BeautyBox.value === 2} onChange={this.handleBeautyBoxChange}>
                        <Trans defaults='Beauty table' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2OwnersCabin);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-OwnersCabin.js